// socket.js
import { io } from "socket.io-client";

let socket;
export const getSocket = () => {
    const SocketUrl = process.env.REACT_APP_SOCKET_URL
    if (!socket) {
        socket = io(SocketUrl, {
            path: "/api/socket.io/",
            transports: ["websocket"],
            withCredentials: true,
        });
    }
    return socket;
};
